<span ngbDropdown [autoClose]="true" class="asset-type-filter">
  <button type="button" class="btn filter-btn" ngbDropdownToggle
    [class.filter-btn--placeholder]="isPlaceholder">
    <span class="filter-btn__label">{{ label }}</span>
    <i class="ph ph-caret-down"></i>
  </button>

  <div ngbDropdownMenu class="filter-dropdown">
    <button class="filter-dropdown__item" ngbDropdownItem (click)="onSelect(null)">All</button>
    @for(type of assetTypes; track type.value) {
      <button class="filter-dropdown__item" ngbDropdownItem (click)="onSelect(type)"
        [class.filter-dropdown__item--active]="selectedType?.value === type.value">
        {{ type.label }}
      </button>
    }
  </div>
</span>